import { select, put } from 'redux-saga/effects'
import sprigClient from 'APP/Services/Sprig'

import AppSessionActions from 'APP/Redux/AppSessionRedux'
import type { RootState } from 'APP/Store/CreateStore'
import { selectFeatures } from 'APP/Sagas/FeaturesSaga'
import { patientProfileState } from './PatientSagas'

// TODO: move selectors to APP/Store/AppSession/selectors
export const selectIsAppOnline = (state: RootState) => state.appSession.isConnected
export const selectIsAppActive = (state: RootState) => state.appSession.isActive

export function* setIsConnectedIfDisconnected(): Generator {
  const appIsOnline = yield select(selectIsAppOnline)
  if (!appIsOnline) {
    yield put(AppSessionActions.setIsConnected(true))
  }
}

export const WELLNESS_ELLIGIBLE_SERVICES = [
  'wellness_challenges',
  'wellness_content',
  'wellness_habits',
]
export function* updateSprigVisitorAttributes(): Generator {
  const { sprigMXCohort } = yield select(selectFeatures)
  const profile = yield select(patientProfileState)
  const eligibleServices = profile?.eligibleServices
  const hasEligibility = Object.keys(eligibleServices || {}).length > 0
  const hasWellness = Object.entries(eligibleServices || {}).some(
    ([key, value]) => WELLNESS_ELLIGIBLE_SERVICES.includes(key) && value
  )

  sprigClient.setVisitorAttribute('has_wellness', String(hasWellness))
  sprigClient.setVisitorAttribute('sex_at_birth', String(profile?.sex))
  sprigClient.setVisitorAttribute('gender_identity', String(profile?.genderIdentity))
  sprigClient.setVisitorAttribute('mx_journey_cohort', String(sprigMXCohort))
  sprigClient.setVisitorAttribute('has_claimed_eligibility', String(hasEligibility))
}
